<template>
  <div>
    <div
      v-popover:[popoverName]
      class="achievement-preview__wrapper"
      :class="wrapperCss"
    >
      <div class="achievement-preview__icon" :style="iconStyles">
        <Unicon
          :name="iconName"
          fill="#fff"
          height="130"
          width="130"
        />
      </div>
      <div class="subtitle__wrapper">
        <h5 class="achievement-preview__subtitle">
          {{ data.achievement_id.name }}
        </h5>
      </div>
    </div>
    <Popover :name="popoverName" class="achievement-preview__popover">
      <div class="popover__wrapper">
        <p class="wrapper__text">
          {{ data.achievement_id.description }}
        </p>
        <p class="wrapper__notice_date">
          (Выдано {{ formattedDate }})
        </p>
      </div>
    </Popover>
  </div>
</template>

<script>
import { formats } from "@/_shared/constants";
export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
    withPopover: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    wrapperCss() {
      let modifier = 'clickable';
      if (!this.withPopover) {
        modifier = 'unclickable';
      }
      const cssClass = `achievement-preview__wrapper_${modifier}`;
      return [cssClass];
    },
    iconStyles() {
      const value = this.data.achievement_id.icon_background
      return {
        background: value || '#0088cc',
      };
    },
    iconName() {
      return this.data.achievement_id.icon_name;
    },
    popoverName() {
      const number = this.data.id || 1;
      return `achievement-popover-${number}`;
    },
    formattedDate() {
      const format = formats.dates.achievementPreview;
      const date = new Date(this.data.date_of_receiving);
      return date.toLocaleDateString('ru', format);
    },
  },
};
</script>

<style scoped>
.achievement-preview__popover {
  box-shadow: 0px 4px 20px 0px rgb(52 73 94 / 80%);
  min-width: 250px;
}
.achievement-preview__wrapper {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.achievement-preview__wrapper_unclickable {
  pointer-events: none;
}
.achievement-preview__wrapper_clickable:hover,
.achievement-preview__wrapper_clickable:focus {
  opacity: 0.8;
  cursor: pointer;
  transition: 0.5s;
}
.achievement-preview__icon {
  transition: all 0.45s;
  margin: 0 auto;
  background-position: top center;
  border-radius: 50%;
  padding: 0.75em 1em 0.5em 1em;
}
.popover__wrapper {
  text-align: center;
}
.subtitle__wrapper {
  margin: 0 auto;
  max-width: 160px;
}
.achievement-preview__subtitle {
  word-break: break-all;
  text-align: center;
  font-weight: 600;
  font-size: 1.1em;
}
.popover__wrapper .wrapper__text {
  margin-top: 0.5em;
  font-weight: 600;
  word-break: break-all;
}
.popover__wrapper .wrapper__notice_date {
  font-size: 0.8em;
  color: rgb(107, 107, 107);
}
</style>



// WEBPACK FOOTER //
// src/user/features/achievements/AchievementPreview.vue